<template>
  <div :class="['welfareItem',className]">
    <img :src="!showSquaImg ? info.head_img : info.icon2" class="head_img" @click.prevent="click_img" />
    <div class="vip_tag">
        <LevelTag :level="info.growth_level"/>
    </div>
    <div class="title" @click.prevent="click_img" >{{this.info.award_name}}</div>
    <div class="row">
      <div class="sub_title">{{info.sub_title}}</div>
            <div :class="{button:true,disable_button:this.disable_button}" @click="click_button">{{button_text}}</div>

    </div>
  </div>
</template>
<script>
import { openLink } from "../../../tools/mgtv/link";
import click_handler from "../../../tools/mgtv/click";
import LevelTag from "../LevelTag.vue";

export default {
  name: "WelfareItem",
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          award_id: 520,
          award_name: "奖品名称奖品名称",
          sub_title: "副标题",
          head_img: "https://via.placeholder.com/340x160?text=MGTV",
          pos: 1,
          growth_level: 1,
          received: 0
        };
      }
    },
    click_button: {
      type: Function,
      default: () => {
        console.log("点击领取按钮");
      }
    },
    click_img: {
      type: Function,
      default: () => {
        console.log("点击福利封面");
      }
    },
    className: {
      type: String,
      default: ''
    },
    showSquaImg: {
      type: Boolean,
      default: false
    }
  },
  components:{LevelTag},
  data: function() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {
     button_text: function() {
      if (!this.info) {
        return "已失效";
      } else if (this.info.received === 1) {
        return "去使用";
      } else if (this.info.out_stock === 1) {
        return "已领完";
      } else {
        return "立刻领取";
      }
    },
    disable_button: function() {
      if (!this.info) {
        return true;
      } else if (this.info.received === 1) {
        return false;
      } else if (this.info.out_stock === 1) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>


<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
.welfareItem
    position relative
    width 3.4rem
    height 2.9rem
    display block
    box-shadow:0px 0.03rem 0.08rem 0.02rem rgba(0,0,0,0.06);
    border-radius: 0.08rem;
    overflow hidden
    .head_img
        position relative
        width 3.4rem
        height 1.6rem
        border-radius: 2px 2px 0 0;
    .vip_tag
        position absolute
        width: 1.2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        left: 0;
        top: 0;
        overflow: hidden;
        font-size: 0.2rem;
        font-weight: 500;
        color: #804919;
    .title
        width 3.4rem
        ellipsis()
        font-size .26rem
        padding 0 .14rem
        margin .2rem 0 .11rem
    .row
        display flex
        align-items center
        padding 0 .14rem
        justify-content space-between
    .sub_title
        font-size: .2rem;
        color: #888888;
        ellipsis()
    .button
        background-image: linear-gradient(90deg, #FEDD9F 0%, #FFC562 100%);
        box-shadow: 0 6px 6px 0 rgba(252,216,151,0.34);
        border-radius: 29px;
        font-size: 22px;
        color: #CB8723;
        width 1rem
        height .42rem
        line-height @height
        font-size .2rem
        text-align center
   .disable_button
      filter grayscale(100%)
.welfareItem.swiper-style
  width: 100%
  box-shadow: unset;
  height: 3.78rem;
  border-radius: 0.16rem;
  .head_img
    position relative
    width 1.6rem
    height 1.6rem
    margin: 0.64rem auto 0.16rem
  .title
    height: 0.4rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: #333333;
    line-height: 0.4rem;
    width: 100%
    margin-top: 0;
    margin-bottom: 0.08rem
  .row
    display: block
  .sub_title
    text-align: center
    height: 0.28rem;
    font-size: 0.24rem;
    font-weight: 500;
    color: #D9AC63;
    line-height: 0.28rem;
  .button
    border-radius: 0.08rem;
    margin: 0.1rem auto;
    display: none;
.welfareItem.random-style
  width: 100%
  box-shadow: unset
  height: 100%
  .head_img
    position relative
    width 1.36rem
    height 1.36rem
    right: 0.2rem
    margin-left: auto;
    display: block
    top:0.24rem;
  .title
    height: 0.4rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: #333333;
    line-height: 0.4rem;
    width: 100%
    margin-top: 0;
    margin-bottom: 0.08rem;
    position: absolute;
    top: 0.52rem;
    width: 60%
  .row
    display: block
    height: 1rem
    position: absolute
    bottom: 0rem
    width: 60%
  .sub_title
    height: 0.28rem;
    font-size: 0.24rem;
    font-weight: 500;
    color: #D9AC63;
    line-height: 0.28rem;
    position: absolute;
    width: 90%;
    top:0.2rem;
  .button
    border-radius: 0.08rem;
    position: absolute;
    bottom:0.2rem;
    left: 0.2rem;
    display: none
</style>
